<div class="main-wrapper">
  <div class="header-wrapper">
    <label class="header-active">{{ 'ExportNotes' | t }}</label>
    <button class="new-note-btn" (click)="addNewNote()">
      <span class="plus-icon">+</span>{{ 'NotesNewNote' | t }}</button>
  </div>
  
  <!-- New Note Input Section -->
  <div class="new-note-input-wrapper" *ngIf="showNewNoteInput">
    <textarea 
      class="new-note-textarea"
      [(ngModel)]="newNoteText"
      [placeholder]="'NotesEnterYourNoteHere' | t"
      (blur)="onBlurSaveNote()"
      (keydown.enter)="onEnterSaveNote($event)"
      (keydown.escape)="cancelNewNote()"
      [disabled]="isSavingNote"
      autofocus>
    </textarea>
    <div class="new-note-hint">
      <span *ngIf="!isSavingNote">{{ 'NotesPressEnterToSaveEscTo' | t }}</span>
      <span *ngIf="isSavingNote">{{ 'NotesSaving' | t }}</span>
    </div>
  </div>
  
  <div class="no-notes" *ngIf="noteCollection.length == 0 && !showNewNoteInput">
    <span>{{ 'NotesNoNotesFound' | t }}</span>
  </div>
  <div class="notes-container">
    <ul>
      <li *ngFor="let n of noteCollection">
        <div class="note-item-wrapper">
          <!-- noteImageSrc is a pure LOOKUP, not a fetch: a binding re-runs on
               every change-detection pass, so the SAS request happens once when
               the notes arrive (resolveNoteImages) and never from here. -->
          <img
            *ngIf="!notePhotoFailure(n); else photoUnavailable"
            [src]="noteImageSrc(n)"
            alt="Image Source"
            (click)="onNoteImageClick(n)"
            (error)="onNoteImageError(n)"
          />
          <!-- A photo that could not be shown is SAID, never drawn as the
               placeholder a note without a photo uses. -->
          <ng-template #photoUnavailable>
            <div
              class="note-photo-unavailable"
              role="img"
              [attr.data-reason]="notePhotoFailure(n)"
              [attr.aria-label]="'NotesPhotoUnavailable' | t"
              [title]="('NotesPhotoUnavailable' | t) + ' (' + notePhotoFailure(n) + ')'"
            >
              {{ 'NotesPhotoUnavailable' | t }}
            </div>
          </ng-template>

          <div class="noteInfo">
            <div class="time">
              {{ n.T | vcDate: 'seconds' }}
            </div>
            <div class="text">
              {{ n.TX }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div class="popup" *ngIf="showImagePopup">
    <img
      [src]="selectedImage"
      style="width: 800px; height: 400px"
      alt="Skaret View"
    />
    <a [routerLink]="" class="closeBtn" (click)="closePopup()">X</a>
  </div>
</div>
